var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "tw-mb-1 tw-flex tw-items-center tw-gap-2"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.category === 'today' ? 'primary' : 'outline-primary',
      "size": "sm"
    },
    on: {
      "click": _vm.selectToday
    }
  }, [_vm._v(" Today ")]), _c('b-button', {
    attrs: {
      "variant": _vm.category === 'custom' ? 'primary' : 'outline-primary',
      "size": "sm"
    },
    on: {
      "click": _vm.selectCustomRange
    }
  }, [_vm._v(" Custom Range ")]), _vm.category === 'custom' ? _c('BaseDateTimePicker', {
    attrs: {
      "trigger": "",
      "trigger-label": _vm.dateRangeLabel
    },
    on: {
      "apply": _vm.applyDateRange
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "tw-mb-4 tw-flex tw-items-center tw-justify-between"
  }, [_c('p', {
    staticClass: "tw-mb-0 tw-text-xs tw-text-gray-500"
  }, [_vm._v(" " + _vm._s(_vm.reportDescription) + " ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "disabled": _vm.isExporting
    },
    on: {
      "click": _vm.exportToCSV
    }
  }, [_c('b-icon', {
    staticClass: "tw-mr-2",
    attrs: {
      "icon": "download"
    }
  }), _vm._v(" " + _vm._s(_vm.isExporting ? 'Exporting...' : 'Export Data') + " ")], 1)], 1), _c('DoctorDelinquentReportsTable', {
    ref: "table",
    attrs: {
      "category": _vm.category,
      "date-range": _vm.dateRange
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };